module.exports = __webpack_public_path__ + "img/banner1.7610635e.png";